import React from "react";

import { cn } from "@/lib/helpers/cn";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getVersionedConsentHref } from "@/lib/helpers/getVersionedConsentHref";
import Input from "@/components/UI/Input";
import { Link2 } from "@/ui2/atoms/Link";

type Props = {
  consentEvent: VoidFunction;
  className?: string;
  version?: string;
};

export function ConsentToTreatment({ consentEvent, className, version }: Props) {
  const consentHref = getVersionedConsentHref({ policy: "treatment", version });

  return (
    <label
      className={cn(
        "tw:mb-0! tw:inline-flex! tw:cursor-pointer tw:items-baseline tw:gap-3 tw:rounded-md tw:bg-fill-senary tw:p-4",
        className,
      )}
      {...getAutomationDataAttr("consent-to-treatment-checkbox")}
    >
      <Input onClick={consentEvent} name="consent" type="checkbox" />

      <p className="tw:mb-0! tw:text-md tw:text-text-tertiary">
        I acknowledge that I have read and agreed to aptihealth’s{" "}
        <Link2
          href={consentHref}
          isExternal
          {...getAutomationDataAttr("consent-to-treatment-link")}
        >
          Consent to Treatment
        </Link2>
      </p>
    </label>
  );
}
